import React from 'react';
import InputMask from 'react-input-mask';
import { Label } from 'reactstrap';
import { ToolTipFeedBack } from '../Utils/ToolTipFeedBack';
import { translate } from '../../_helpers/messages.helper';
import { connect } from 'react-redux';

type Props = {
  label: string,
  name: string,
  id: string,
  value?: string | string[] | number,
  size?: number,
  onChange: any,
  onBlur: any,
  children?: any,
  required: boolean,
  messageValidate?: string,
  placeholder: string,
  disabled: boolean,
  maxLength: number,
  style: any
};
class PhoneInput extends React.Component<Props> {
  static defaultProps = {
    size: 12
  };
  constructor(props: Props) {
    super(props);
  }


  render() {
    const { messages, name } = this.props;
    const value = this.props.value || '';
    let mask;
    let match = value.match(/\d+/g);

    if (match != null && match.join('').length < 11) {
      mask = '(99) 9999-99999';
    } else {
      mask = '(99) 99999-9999';
    }


    let messageValidate;
    if (messages != null && messages.length > 0) {
      messages.forEach(function (message, index) {
        if (message.fieldName == name) {
          messageValidate = translate(message.message.code);
        }
      });
    }
    if (this.props.erroMensagem) {
      messageValidate = this.props.erroMensagem;
    }
    return (
      <div className={`${this.props.required ? "input-required" : ""}`}>
        {this.props.label && (
          <Label for={this.props.name} className='label-nowrap' title={this.props.label}>
            {this.props.label}
            {this.props.required && '*'}
          </Label>
        )}
        <InputMask
          mask={mask}
          maskChar=" "
          id={this.props.id}
          name={this.props.name}
          value={value}
          onChange={this.props.onChange}
          autoComplete='new-password'
          required={this.props.required}
          placeholder={this.props.placeholder === "" || this.props.placeholder === undefined ? this.props.label : this.props.placeholder}
          onBlur={this.props.onBlur}
          disabled={this.props.disabled ? this.props.disabled : false}
          className={`form-control ${this.props.className} ${messageValidate ? 'is-invalid' : ''}`}
        >
          {this.props.children}
        </InputMask>
        {messageValidate && (
          <ToolTipFeedBack
            target={this.props.id}
            messageValidate={messageValidate}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { messages } = state.fieldMessage;
  const { alert } = state;

  return {
    messages,
    alert
  };
}

export default connect(mapStateToProps)(PhoneInput);
